/* eslint-disable */
/**
 * DEPRECATED: This file is kept for backward compatibility
 * New modular structure is in ./userExtAnalytics/
 * 
 * - bugsnag.js - Bugsnag error tracking & performance
 * - amplitude.js - Amplitude analytics
 * - googleAnalytics.js - Google Analytics events
 * - plausible.js - Plausible analytics (with normalizer)
 * - hotjar.js - Hotjar session recording
 * - userExtAnalytics.js - Main orchestrator
 */

import innerObject from './userExtAnalytics/userExtAnalytics.js';

// Re-export from modular structure

export default innerObject;